// Default labels for system-specific risk report blocks

export const DEFAULT_RISK_ROWS = {
  rakennetekniikka: [
    "Vierustat ja kuivatusosat",
    "Pihapäällysteet",
    "Aluevarusteet ja -rakenteet",
    "Perustukset ja sokkelit",
    "Alapohja",
    "Rakennusrunko",
    "Ulkoseinät",
    "Ikkunat",
    "Ulko-ovet",
    "Parvekkeet",
    "Kattorakenteet",
    "Tekniset tilat",
    "Sisätilat",
    "Märkätilat",
  ],

  sähkotejärjestelmät: [
    "Aluesähköistys",
    "Kytkinlaitokset ja jakokeskukset",
    "Johdot ja niiden varusteet",
    "Valaisimet, lämmittimet, kojeet ja laitteet",
    "Tele- ja antennijärjestelmät",
    "Palo- ja turvajärjestelmät",
    "Siirtolaitteet",
  ],

  LVIjärjestelmät: [
    "Lämmöntuotanto",
    "Lämmitysverkosto",
    "Vesijohtoverkosto",
    "Viemäriverkosto",
    "Ilmanvaihtojärjestelmä",
    "Jäähdytysjärjestelmät",
    "Rakennusautomaatio",
  ],
};
